import React, { useState } from "react";
import { Button, Input } from "../../../controls";
import { action, API, controller } from "../../../api/api";
import { lsGet, PrintDiv, ToFormData } from "../../../hooks/Method";
import { useNavigate } from "react-router-dom";
import { Alert } from "../../../layout";
import PrintReceipt from "../../Sales/SaleReturn/PrintReceipt/PrintReceipt";

const Header = ({ setSellItems, values }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [printData, setPrintData] = useState();
  const activeReg = lsGet("activeReg");
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleCancel = () => {
    navigate(-1);
  };

  const handleFilter = (val) => {
    setSellItems([
      ...values.returnItems.filter(
        (i) =>
          i.prod &&
          (i.prod.name.toLowerCase().includes(val.toLowerCase()) ||
            i.prod.skuCode.toLowerCase().includes(val.toLowerCase()) ||
            (i.varProd &&
              i.varProd.skuCode.toLowerCase().includes(val.toLowerCase())))
      ),
    ]);
  };

  const handleSubmit = (e) => {
    if (activeReg && values.returnItems.length > 0) {
      e.preventDefault();
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && res.status === 200) {
          // Print Receipt
          if (res.result && res.result.id) {
            setPrintData({ ...res.result });
            setTimeout(() => {
              PrintDiv("printReturnReceipt");
              // Back to previous page.
              handleCancel();
            }, 500);
          }
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      API(controller.SellReturn + action.Post).post(
        ToFormData({
          ...values,
          outlet: "",
          outletId: activeReg.outletId,
          returnItems: values.returnItems
            .filter((j) => parseFloat(j.returnQty || 0) > 0)
            .map((j) => ({
              ...j,
              prod: "",
              varProd: "",
              id: "",
            })),
        }),
        onComplete
      );
    } else if (values.returnItems.length === 0)
      setAlert({
        isOpen: true,
        type: "error",
        title: "No Items to Return",
        subTitle: "Please add items to your return list before submitting.",
      });
    else console.error("Please open a register first.");
  };

  return (
    <>
      <div className="d-none" id="printReturnReceipt">
        {printData && printData.id && <PrintReceipt data={printData} />}
      </div>

      <div className="flex justify-between items-center w-full flex-wrap gap-3 md:gap-4">
        {/* Title Section */}
        <div className="min-w-0">
          <span className="text-gray-500 border-left border-gray-500 pl-2 ml-1 font-semibold uppercase tracking-wider text-[20px]">
            Sell Return
          </span>
        </div>

        {/* Search and Buttons Section */}
        <div className="flex flex-col md:flex-row md:items-center gap-2.5 md:gap-3 w-full md:w-auto">
          {/* Search Input */}
          <div className="order-last md:order-none w-full md:w-[250px]">
            <Input
              onChange={(e) => handleFilter(e.target.value)}
              size="small"
              className="text-gray-600 w-full"
              placeholder="Search..."
            />
          </div>

          {/* Cancel Button */}
          <div className="order-2 md:order-none w-full md:w-[150px]">
            <Button onClick={handleCancel} variant="text" className="w-full">
              Cancel
            </Button>
          </div>

          {/* Submit Button */}
          <div className="order-1 md:order-none w-full md:w-[200px]">
            <Button
              onClick={handleSubmit}
              loading={loading}
              color="error"
              className="w-full"
            >
              Submit Return
            </Button>
          </div>
        </div>
      </div>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Header;
